<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
  </div>

  <!-- Modal close -->
  <div class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default" v-show="(detailModal || approvalModal)" @click="detailModal = false, approvalModal = false" />

  <!-- Approval Modal -->
  <vue-final-modal
    v-model="approvalModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Information</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="approvalModal = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
      <div v-if="filter.state != 'Rejected'" class="warning">{{ $t('menu.warning') }}</div>
      <div v-if="filter.state != 'Rejected'" class="messsage"><p>Are you sure?</p></div>

      <field v-if="filter.state == 'Rejected'" :label="$t('Reason')" class="form-col-input-full form-select">
        <textarea v-model="filter.reason" style="width: -webkit-fill-available !important; height: 150px;" />
      </field>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
      <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" @click="confirm" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="cancel" class="btn-reset form-noicon-btn" />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <!-- Detail modal -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="relative h-5/6 flex flex-col mx-4 md:mx-0 pb-4 w-11/12 md:w-2/3 lg:w-1/2"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>Detail Approval</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="detailModal = false" />
    </div>

    <!-- Modal Content -->
    <div class="modal-content detail-content">
      <approval-detail
        :prop-class="hrreqleaveObject"
        @close-modal="detailModal = false"
        @refresh-list="refresh"
        @reset-modal="null"
      />
    </div>
  </vue-final-modal>

  <div class="shadow overflow-hidden">
    <div>
      <dl>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Transaction No.') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.transaction_no }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Transaction Date') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.transaction_date }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('School') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.school_name }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Branch') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.branch_name }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Employee') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.employee_name }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Academic Year') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.academic_year_name }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Year') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.year }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Leave') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.leave_name }}
          </dd>
        </div>
        <div v-if="reqleave.leave_type != 'Permission'" class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Start - End Date') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.start_date+' - '+reqleave.end_date }}
          </dd>
        </div>
        <div v-if="reqleave.leave_type == 'Permission'" class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Start - End Time') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.start_time+' - '+reqleave.end_time }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Description') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.description }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('State') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.state }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Creator') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.created_by }}
          </dd>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Comment') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
            {{ reqleave.comment }}
          </dd>
        </div>
      </dl>

      <!-- Leave Approval -->
      <card-component
        class="mt-2"
        :title="$t('Leave Approval')"
        :icon="mdiDatabase"
        :sendapproveShow="reqleave.state == 'Draft' ? true : false"
        @sendapprove-click="approvalModalShow('Waiting for Approval', null, 'all')"
        :approveShow="false"
        @approve-click="approvalModalShow('Approved', null, 'all')"
        @reject-click="approvalModalShow('Rejected', null, 'all')"
        has-table
      >
        <ag-grid-vue
          style="width: 100%; height: 70vh;"
          class="ag-theme-alpine"
          :defaultColDef="defaultColDef"
          :columnDefs="columnDefs"
          :pagination="true"
          :context="context"
          @grid-ready="onGridReady"
          :rowData="filteredData"
        />
      </card-component>
    </div>
  </div>

</template>
<script>
/* eslint-disable */
import axios from 'axios'
import { mdiDatabase, mdiTrashCan, mdiClose } from '@mdi/js'
import { ref, reactive, watchEffect, watch } from 'vue'
import CardComponent from '@/components/CardComponent'
import { AgGridVue } from 'ag-grid-vue3'
import ButtonApprove from '@/components/ButtonApprove'
import { useI18n } from 'vue-i18n'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { useToast } from 'vue-toastification'
import JbButtons from '@/components/JbButtons'
import JbButton from '@/components/JbButton'
import Field from '@/components/Field'
import ApprovalDetail from '@/views/humanresource/hrreqleave/ApprovalDetail'

export default {
  name: 'ClassForm',
  components: {
    Loading,
    CardComponent,
    AgGridVue,
    JbButtons,
    JbButton,
    Field,
    ButtonApprove,
    ApprovalDetail
  },
  props: {
    propClass: {
      type: Object,
      default: () => ({ empty: true })
    }
  },
  data: function () {
    return {
    }
  },
  emits: ['close-modal', 'submit'],
  setup (props, { emit }) {
    const titleStack = ref(['Admin', 'Forms'])
    const isLoading = ref(false)
    const { t } = useI18n()
    const toast = useToast()

    const filteredData = ref([])
    const reqleave = reactive({})

    watchEffect(() => {
      const newKelas = props.propClass
      Object.assign(reqleave, newKelas)
    })

    // Leave Approval
    const isApprove = ref(0)
    const refresh = async() => {
      isLoading.value = true

      reqleave.user_id = localStorage.getItem('user_id')
      const params = reqleave
      const url = 'leave-approval'
      const method = 'GET'

      await axios({
          method,
          url,
          params
        })
        .then(response => {
          // assign state kelass with response data
          isLoading.value = false
          filteredData.value = response.data.data
          isApprove.value = response.data.isApprove
        }).catch(error => {
          isLoading.value = false
          console.log(error)
        })
    }

    watch(() => reqleave.id, (newVal, oldVal) => {
      if(reqleave.id){
        refresh()
      } else {
        filteredData.value = []
        isApprove.value = 0
      }
    })

    const defaultColDef = {
      resizable: true
    }
    const columnDefs = [
      {
        field: 'id',
        headerName: t('main.action'),
        cellStyle: params => {
          if (params.data.state == 'Rejected') {
            return { color: 'red' };
          }
        },
        sortable: true,
        filter: true,
        minWidth: 150,
        cellRendererFramework: 'ButtonApprove'
      },
      {
        field: 'position',
        headerName: t('Position'),
        cellStyle: params => {
          if (params.data.state == 'Rejected') {
            return { color: 'red' };
          }
        },
        sortable: true,
        filter: true,
        minWidth: 200,
        suppressSizeToFit: true
      },
      {
        field: 'user_name',
        headerName: t('Approver User'),
        cellStyle: params => {
          if (params.data.state == 'Rejected') {
            return { color: 'red' };
          }
        },
        sortable: true,
        filter: true,
        minWidth: 200,
        suppressSizeToFit: true
      },
      {
        field: 'state',
        headerName: t('State'),
        cellStyle: params => {
          if (params.data.state == 'Rejected') {
            return { color: 'red' };
          }
        },
        sortable: true,
        filter: true,
        minWidth: 200,
        suppressSizeToFit: true
      },
      {
        field: 'action_date',
        headerName: t('Action Date'),
        cellStyle: params => {
          if (params.data.state == 'Rejected') {
            return { color: 'red' };
          }
        },
        sortable: true,
        filter: true,
        minWidth: 150,
        suppressSizeToFit: true
      },
      {
        field: 'reason',
        headerName: t('Reason'),
        cellStyle: params => {
          if (params.data.state == 'Rejected') {
            return { color: 'red' };
          }
        },
        sortable: true,
        filter: true,
        minWidth: 250,
        suppressSizeToFit: true
      }
    ]

    const filter = reactive({
      id: '',
      state: '',
      reason: '',
      is_all: 'not',
      updated_by: localStorage.getItem('name')
    })

    const approvalModal = ref(false)
    const confirm = () => confirmApproval()
    const cancel = () => approvalModal.value = false
    const approvalModalShow = (value, id, type) => {
      approvalModal.value = true
      filter.state = value
      filter.id = id
      filter.is_all = type
    }
    const confirmApproval = () => {
      isLoading.value = true

      const params = {
        id: reqleave.id,
        employee_id: reqleave.employee_id,
        school_id: reqleave.school_id,
        branch_id: reqleave.branch_id,
        state: filter.state,
        reason: filter.reason,
        approval_id: filter.id,
        is_all: filter.is_all,
        user_id: localStorage.getItem('user_id'),
        updated_by: filter.updated_by,
      }
      const url = 'leave-send-approval'
      const method = 'POST'

      axios({
          method,
          url,
          params
        })
        .then(response => {
          if (response.data.success) {
            if(response.data.state != ''){
              reqleave.state = response.data.state
            }

            refresh()
            emit('reset-modal')
            emit('close-modal')
            emit('refresh-list')
            approvalModal.value = false
            toast.success(t(response.data.message), {
              timeout: 5000
            })
          } else {
            toast.error(t(response.data.message), {
              timeout: 5000
            })
          }
          isLoading.value = false
        }).catch(error => {
          console.log(error)
          isLoading.value = false
        })
    }

    const detailModal = ref(false)
    const approvalObject = ref()
    const detailData = (event, kelas) => {
      detailModal.value = true
      approvalObject.value = kelas
    }

    const approveClick = (sts, data, id) => {
      if (sts == 'Approved') {
        approvalModalShow('Approved', id, 'not')
      } else if (sts == 'Rejected') {
        approvalModalShow('Rejected', id, 'not')
      // } else if (sts == 'Remove') {
      //   approveStore(sts, data, id)
      }
    }

    return {
      isLoading,
      confirm,
      cancel,
      approvalModal,
      approvalModalShow,
      confirmApproval,
      refresh,
      mdiDatabase,
      mdiTrashCan,
      mdiClose,
      filter,
      detailData,
      detailModal,
      approvalObject,
      approveClick,

      titleStack,
      filteredData,
      isApprove,
      defaultColDef,
      columnDefs,
      reqleave
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach((column) => {
        allColumnIds.push(column.colId)
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, false)
    }
  }
}
</script>
